export type Validator<T = any> = (data?: any) => data is T;

// eslint-disable-next-line @typescript-eslint/ban-types
export function object(data?: any): data is object {
  return typeof data === 'object';
}

export function string(data?: any): data is string {
  return typeof data === 'string';
}

export function bool(data?: any): data is boolean {
  return typeof data === 'boolean';
}

export function optional<T>(validator: (data?: any) => boolean): Validator<T> {
  return (data?: any): data is T => {
    if (!data) return true;
    return validator(data);
  };
}

export function every<T>(validator: Validator<T>): Validator<T[]> {
  return (data?: any): data is T[] => {
    if (!Array.isArray(data)) return false;
    return data.every(validator);
  };
}
